import React from "react";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";
import {
  IconAdd,
  IconArrowLeft,
  IconArrowOutward,
  IconArrowRight,
  IconAvailability,
  IconBlock,
  IconCalculate,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconClose,
  IconColor,
  IconDelete,
  IconEdit,
  IconError,
  IconExport,
  IconFilter,
  IconForm,
  IconGlobal,
  IconHelp,
  IconHome,
  IconImport,
  IconInfo,
  IconLessonAllocation,
  IconLessonPattern,
  IconLock,
  IconLogOut,
  IconMail,
  IconManualRegistration,
  IconMenu,
  IconNote,
  IconNotification,
  IconPreview,
  IconProfile,
  IconRemove,
  IconRoom,
  IconRules,
  IconSave,
  IconSchoolClass,
  IconSearch,
  IconSettings,
  IconSort,
  IconStudent,
  IconSubject,
  IconSuccess,
  IconTeacher,
  IconTime,
  IconTimetable,
  IconUndo,
  IconWarning,
} from "../../../../icons";

const iconItems = [
  { name: "IconAdd", Icon: IconAdd },
  { name: "IconArrowLeft", Icon: IconArrowLeft },
  { name: "IconArrowOutward", Icon: IconArrowOutward },
  { name: "IconArrowRight", Icon: IconArrowRight },
  { name: "IconAvailability", Icon: IconAvailability },
  { name: "IconBlock", Icon: IconBlock },
  { name: "IconCalculate", Icon: IconCalculate },
  { name: "IconCheck", Icon: IconCheck },
  { name: "IconChevronDown", Icon: IconChevronDown },
  { name: "IconChevronLeft", Icon: IconChevronLeft },
  { name: "IconChevronRight", Icon: IconChevronRight },
  { name: "IconChevronUp", Icon: IconChevronUp },
  { name: "IconClose", Icon: IconClose },
  { name: "IconColor", Icon: IconColor },
  { name: "IconDelete", Icon: IconDelete },
  { name: "IconEdit", Icon: IconEdit },
  { name: "IconError", Icon: IconError },
  { name: "IconExport", Icon: IconExport },
  { name: "IconFilter", Icon: IconFilter },
  { name: "IconForm", Icon: IconForm },
  { name: "IconGlobal", Icon: IconGlobal },
  { name: "IconHelp", Icon: IconHelp },
  { name: "IconHome", Icon: IconHome },
  { name: "IconImport", Icon: IconImport },
  { name: "IconInfo", Icon: IconInfo },
  { name: "IconLessonAllocation", Icon: IconLessonAllocation },
  { name: "IconLessonPattern", Icon: IconLessonPattern },
  { name: "IconLock", Icon: IconLock },
  { name: "IconLogOut", Icon: IconLogOut },
  { name: "IconMail", Icon: IconMail },
  { name: "IconManualRegistration", Icon: IconManualRegistration },
  { name: "IconMenu", Icon: IconMenu },
  { name: "IconNote", Icon: IconNote },
  { name: "IconNotification", Icon: IconNotification },
  { name: "IconPreview", Icon: IconPreview },
  { name: "IconProfile", Icon: IconProfile },
  { name: "IconRemove", Icon: IconRemove },
  { name: "IconRoom", Icon: IconRoom },
  { name: "IconRules", Icon: IconRules },
  { name: "IconSave", Icon: IconSave },
  { name: "IconSchoolClass", Icon: IconSchoolClass },
  { name: "IconSearch", Icon: IconSearch },
  { name: "IconSettings", Icon: IconSettings },
  { name: "IconSort", Icon: IconSort },
  { name: "IconStudent", Icon: IconStudent },
  { name: "IconSubject", Icon: IconSubject },
  { name: "IconSuccess", Icon: IconSuccess },
  { name: "IconTeacher", Icon: IconTeacher },
  { name: "IconTime", Icon: IconTime },
  { name: "IconTimetable", Icon: IconTimetable },
  { name: "IconUndo", Icon: IconUndo },
  { name: "IconWarning", Icon: IconWarning },
];

const iconSizePairs = [
  { text: "12px Text", icon: "14px Icon" },
  { text: "13px Text", icon: "16px Icon" },
  { text: "14px Text", icon: "18px Icon" },
  { text: "16px Text", icon: "20px Icon" },
];

function IconUsageRule() {
  return (
    <DocsNiceToKnow className="ds-docs-icons-usage-rule">
      <p className="ds-docs-icons-usage-rule__intro">
        <strong>Anwendungsregel</strong> Inline-Icons sind in der Regel 2–4px grösser als die zugehörige Schrift.
        Bevorzugte Paarung:
      </p>

      <div className="ds-docs-icons-size-scale" aria-label="Bevorzugte Paarung von Schrift- und Icon-Grösse">
        {iconSizePairs.map((pair) => (
          <div key={pair.text} className="ds-docs-icons-size-scale__item">
            <span>{pair.text}</span>
            <span aria-hidden="true">→</span>
            <strong>{pair.icon}</strong>
          </div>
        ))}
      </div>

      <p className="ds-docs-icons-usage-rule__note">
        → Komponenten wie Buttons, Chips, Card-Header etc. bringen Icon-Grösse automatisch mit.
      </p>
    </DocsNiceToKnow>
  );
}

function IconCatalogItem({ item }) {
  const { name, Icon } = item;

  return (
    <div className="ds-docs-icon-catalog-item">
      <span className="ds-docs-icon-catalog-item__preview" aria-hidden="true">
        <Icon sx={{ fontSize: 20 }} />
      </span>
      <span className="ds-docs-icon-catalog-item__name">{name}</span>
    </div>
  );
}

export default function IconsDocs() {
  return (
    <DocsSectionCard title="Icons">
      <div className="ds-docs-icons-sheet">
        <IconUsageRule />

        <DocsPreviewPanel label="Icon-Katalog" icon={IconSearch} className="ds-docs-icons-catalog-panel">
          <div className="ds-docs-icon-catalog">
            {iconItems.map((item) => (
              <IconCatalogItem key={item.name} item={item} />
            ))}
          </div>
        </DocsPreviewPanel>
      </div>
    </DocsSectionCard>
  );
}
